import React from 'react'
import styles from './style.module.scss'

import settings from 'popups/Settings'
import i18n from 'i18n'

import moment from 'moment'

interface TimeSlot {
  time: string
  period: string
  secondaryTime: string | null
}

const PeriodView = ({ targetDate }) => {
  const HOURS_IN_DAY = 24
  const format = settings.getValue('general').timeFormat as string
  const locale = settings.getValue('general').locale as string
  const calSettings = settings.getValue('calendar') as any
  const secondaryTimezone = calSettings.secondaryTimezone as string
  const showSecondTz = calSettings.showSecondaryTimezone as boolean

  const get24HourString = (date: Date): string => {
    return date.toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
  }

  const get12HourString = (date: Date): string => {
    return date.toLocaleTimeString(locale, {
      hour: 'numeric',
      hour12: true,
    })
  }

  const get12HourMinuteString = (date: Date): string => {
    return date.toLocaleTimeString(locale, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
  }

  // 시간대 생성 (00:00 ~ 23:00, 1시간 간격)
  const hourSlots: (TimeSlot | string)[] = Array.from({ length: HOURS_IN_DAY }, (_, i) => {
    if (i === 0) return ''
    const date = targetDate instanceof Date ? new Date(targetDate) : new Date()
    date.setHours(i, 0, 0, 0)
    let ret = ''
    if (i === 12) {
      if (format === 'HH:mm') {
        ret = get24HourString(date)
      } else {
        ret = i18n.t('common.time.noon')
      }
    } else if (format === 'HH:mm') {
      ret = get24HourString(date)
    } else {
      ret = get12HourString(date)
    }

    let secondaryTime: string | null = null
    if (showSecondTz && secondaryTimezone) {
      const momentDate = moment(date).tz(secondaryTimezone)
      const secondaryDate = new Date()
      const h = momentDate.get('hour')
      const m = momentDate.get('minute')
      secondaryDate.setHours(h, m, 0, 0)

      if (h === 12) {
        if (format === 'HH:mm') {
          secondaryTime = get24HourString(secondaryDate)
        } else {
          if (m > 0) {
            secondaryTime = get12HourMinuteString(secondaryDate)
          } else {
            secondaryTime = get12HourString(secondaryDate)
          }
          if (locale.startsWith('ja')) {
            // 일본어 상태의 정오는 0시로 전달되어 replace 처리.
            secondaryTime = secondaryTime.replace('午後0', '午後12')
          }
        }
        secondaryTime = '☀️ ' + secondaryTime
      } else {
        if (format === 'HH:mm') {
          secondaryTime = get24HourString(secondaryDate)
        } else {
          if (m > 0) {
            secondaryTime = get12HourMinuteString(secondaryDate)
          } else {
            secondaryTime = get12HourString(secondaryDate)
          }
        }
        if (h === 0) {
          secondaryTime = '🌙 ' + secondaryTime
        }
      }
    }
    return { time: ret, period: '', secondaryTime: secondaryTime }
  })

  return (
    <div className={styles.periodView}>
      {hourSlots.map((timeSlot, index) => {
        if (typeof timeSlot === 'string') {
          return (
            <div key={index} className={styles.periodItem}>
              <div className={styles.text}></div>
            </div>
          )
        }

        const time = timeSlot as TimeSlot
        return (
          <div key={index} className={styles.periodItem}>
            <div className={styles.text}>
              {time.time}

              {time.period !== '' && (
                <>
                  <div>&nbsp;</div>
                  <div className={styles.period}>{time.period}</div>
                </>
              )}
            </div>
            {showSecondTz && secondaryTimezone && (
              <div className={styles.secondaryTimezone}>{time.secondaryTime}</div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default PeriodView
